import React, { Component } from "react";
import DeleteIcon from '@material-ui/icons/Delete';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import Select from 'react-select';

import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";
import Logout from "./../../loginService/logout";

import { NotificationManager, NotificationContainer } from 'react-notifications';

const backend = require('../../config.js').backend;

class AddOfficeDesigPopup extends Component {

    constructor(props) {

        super(props);
        // super();

        this.state = {
            desigs: {},
            desigId: '',
            redirectLogout: false
        }
    }


    componentDidMount() {

        this.getAllDesignames()
            .then((desigs) => {
                // console.log(desigs)
                this.setState({ desigs: desigs });
            })

    }

    getAllDesignames = _ => {

        var that = this;

        return new Promise(function (resolve, reject) {

            var url = `api/v1/gift/alldesignames`;
            fetch(backend + url, {
                method: 'GET',
                credentials: "include"
            })
                .then(response => response.json())
                .then((data) => {
                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else {
                        resolve(data);
                    }
                })
                .catch((err) => {
                    //   console.log('getAllDesignames error', err);
                    reject(err)
                })

        })

    }


    renderDesigList = () => {

        const { desigs } = this.state;
        var desigsList = [];

        Object.keys(desigs).forEach(function (key) {
            desigsList.push({
                'value': key,
                'label': desigs[key]
            })
        });

        desigsList.sort((a, b) => (a.label > b.label) ? 1 : -1);

        return desigsList
    }

    handleConfirm = () => {
        var { desigId } = this.state;

        if (desigId === '') {
            NotificationManager.error('Please choose the designation.');
        }
        else {

            const { desigs } = this.state;
            const desigName = desigs[desigId];

            var newDesig = {
                DesigId: desigId,
                DesigName: desigName
            }

            this.props.updateDesigOfficeDonationAcc(desigId, 1)
                .then((result) => {
                    NotificationManager.success(desigName + ' is added successfully');
                    this.props.addToDesigList(newDesig);
                    this.props.closePopup();
                })
                .catch((err) => {
                    NotificationManager.error('Cannot add designation, due to ' + err.toString());
                });


        }

    }





    handleCancel = _ => {
        // console.log('handleCancel')
        this.props.closePopup();
    }


    handleChangeSourceFund = (desig) => {
        this.setState({ desigId: desig.value });
    }


    render() {

        var desigsList = this.renderDesigList();
        const { redirectLogout } = this.state;

        if (redirectLogout) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/logout" component={Logout} />
                        <Redirect to="/logout" />
                    </Switch>
                </BrowserRouter>
            )
        }

        return (

            <div className='popup_inner'>

                <div className="new-bankacc col-md-12">

                    <div className='col-md-3'>
                        <label>
                            Add New Designation
                        </label>
                    </div>

                    <div className='input col-md-5'>
                        <div className="btn-group">
                            <Select
                                className='react-select-container'
                                width='200px'
                                options={desigsList}
                                isSearchable="true"
                                placeholder="Choose Designation"
                                onChange={this.handleChangeSourceFund}
                            />
                        </div>
                    </div>

                    <div className='row col-md-4'>
                        <button className='btn-primary' onClick={() => this.handleConfirm()}>Confirm</button>
                        <button className='btn-primary' onClick={this.handleCancel}>Cancel</button>
                    </div>

                </div>
                <NotificationContainer />

            </div>

        )

    }

}



class Office_Desigs_Mgm extends Component {

    constructor(props) {

        super(props);

        this.state = {
            desigs: [],
            showPopup: false,
            loading: true,
            redirectLogout: false
        }
        this.togglePopup = this.togglePopup.bind(this);
        this.handleNewOfficeDesig = this.handleNewOfficeDesig.bind(this);

    }


    componentDidMount() {

        this.getAllOfficeDesigs()
            .then((desigs) => {
                this.setState({ desigs: desigs }, () => {
                    this.setState({ loading: false })
                });
            })

    }

    togglePopup = _ => {
        // console.log('togglePopup');
        this.setState({ showPopup: !this.state.showPopup });
    }

    handleNewOfficeDesig = _ => {
        this.togglePopup();
    }


    deleteFromDesigsList = (id) => {
        this.setState({ desigs: this.state.desigs.filter(desig => desig.DesigId !== id) })
    }


    addToDesigList = (desig) => {

        var { desigs } = this.state;

        if (desig && !this.isDesigInList(desig.DesigId)) {

            desigs.push(desig);
            this.setState({ desigs: desigs });

        }

    }

    isDesigInList = (id) => {

        var newArray = this.state.desigs.filter(desig => (desig.DesigId).toString() === id.toString())
        return (newArray.length)
    }


    getAllOfficeDesigs = _ => {

        var that = this;

        return new Promise(function (resolve, reject) {

            var url = `api/v1/desig/officedonationacc/all`;

            fetch(backend + url, {
                method: 'GET',
                credentials: "include"
            })
                .then(response => response.json())
                .then((data) => {
                    //   console.log(data);
                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else {
                        resolve(data);
                    }

                })
                .catch((err) => {
                    //   console.log('getAllOfficeDesigs error', err);
                    reject(err)
                })

        })

    }


    handleDeleteOfficeDesig = (DesigId, DesigName) => {

        var answer = window.confirm("Are you sure you want to remove " + DesigName + " from office directed designation group?")

        if (answer) {

            this.updateDesigOfficeDonationAcc(DesigId, 0)
                .then((result) => {
                    NotificationManager.success(DesigName + ' is deleted successfully.');
                    this.deleteFromDesigsList(DesigId);
                })
                .catch((err) => {
                    NotificationManager.error('Cannot delete designation, due to ' + err.toString());
                });

        }

    }


    updateDesigOfficeDonationAcc = (desigId, value) => {

        var that = this;

        return new Promise(function (resolve, reject) {

            fetch(backend + `api/v1/desig/officedonationacc/` + desigId + '/' + value, {
                method: 'PUT',
                credentials: "include"
            })
                .then(response => response.json())
                .then(response => {
                    // console.log(response);
                    if (response.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else if (response.status === 500) {
                        reject(response.message)
                    }
                    else {
                        resolve(response);
                    }
                })
                .catch(function (v) {
                    // console.log('error: ', v);
                    reject(v);
                });

        });

    }


    renderRows = desig => {
        return (
            <tr key={desig.DesigId}>
                <td>{desig.DesigId}</td>
                <td>{desig.DesigName}</td>
                <td><DeleteIcon onClick={() => this.handleDeleteOfficeDesig(desig.DesigId, desig.DesigName)} /></td>
            </tr>
        )
    }


    renderTable = _ => {

        const { desigs } = this.state;

        if (desigs.length) {

            return (

                <div className="office-desigs-table">

                    <table className="table table-striped table-hover ">
                        <thead>
                            <tr>
                                <th className='id'>Desig ID</th>
                                <th className='name'>Desig Name</th>
                                <th className='action'>Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {desigs.map(this.renderRows)}
                        </tbody>
                    </table>

                </div>
            )
        }
        else {
            return (
                <div className="office-desigs-table">
                    <h5>No Designations Directed to Office Account</h5>
                </div>
            )
        }


    }


    render() {

        let officeDesigTable = this.renderTable();
        const { redirectLogout } = this.state;

        if (redirectLogout) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/logout" component={Logout} />
                        <Redirect to="/logout" />
                    </Switch>
                </BrowserRouter>
            )
        }

        if (this.state.loading) {

            return (
                <div>
                    <h2>Loading...</h2>
                </div>
            )
        }

        else {

            let content = (
                <div className='bank-acc-mgm'>
                    <h3>Designations Directed To Office Account</h3>

                    <div>

                        {(this.state.showPopup) ?
                            <div className='add_office_desig'>
                                <RemoveCircleOutlineIcon onClick={this.handleNewOfficeDesig.bind(this)} />
                                <label>Add Designation</label>
                                <AddOfficeDesigPopup
                                    closePopup={this.togglePopup.bind(this)}
                                    addToDesigList={this.addToDesigList}
                                    updateDesigOfficeDonationAcc={this.updateDesigOfficeDonationAcc}
                                />
                            </div>
                            :
                            <div className='add_bank_acc'>
                                <AddCircleIcon onClick={this.handleNewOfficeDesig} />
                                <label>Add Designation</label>
                            </div>
                        }
                    </div>

                    <div>
                        {officeDesigTable}
                    </div>
                    <NotificationContainer />

                </div>
            )

            return (content);

        }

    }

}

export default Office_Desigs_Mgm;
